<template>
  <div>
    <div class="search_content_textBox">
      <div class="search_content_textBox_top">검색결과</div>
      <div class="search_content_textBox_bottom">
        <span class="option">{{ returnBoardName() }}</span>에서
        <span class="resultCount">0</span>개가 검색되었습니다.
      </div>
    </div>
    <div class="empty_list">
      <div class="empty_img"></div>
      <div class="empty_text">게시물이 없습니다.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoardEmptySearchLayout",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
    this.type = this.$route.query.type;
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnBoardName() {
      let type =this.type
      switch (type) {
        case "business":
          return '주요사업'
        case "financial":
          return '재무보고'
        case "news":
          return '뉴스'
        case "donate":
          return '나눔&배움'
        case "album":
          return '앨범'
      }
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>